button i{font-size:.95rem;display:flex;align-items:center;justify-content:center}
/*# sourceMappingURL=task-cell-viewer.component-NFLARVOA.css.map */
